/**
 * Convert a payroll amount from either a CSV field or a batch API response.
 * Batch API values may be formatted (for example, "5,092.67") whereas CSV
 * values are normally plain decimals.
 */
export const parsePayrollAmount = (value) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }

  const normalized = String(value ?? "")
    .trim()
    .replace(/[,$\s]/g, "");
  const amount = Number(normalized);

  return Number.isFinite(amount) ? amount : 0;
};

export const sumPayrollAmounts = (records) =>
  Math.round(
    records.reduce((total, record) => total + parsePayrollAmount(record?.amount), 0) *
      100,
  ) / 100;
